module.exports = __webpack_public_path__ + "img/waitReceiving@2x.a810ad18.png";